
















































































import moment from 'moment';
import Vue from 'vue';
import { fetchConfiguracionStreamax } from './../fetchConfiguracionStreamax';
import { AxiosVue } from '@/AxiosVue'; //
import { LoadingService } from '@/services/loadingService';
import { ServicioProxy } from '@/config/enums'; //
import { Component, Prop } from 'vue-property-decorator';
import { Funcionalidades } from '@/config/funcionalidades';
import { EstadoEntidad } from '@/config/enums';
import Confirmation from '@/components/Confirmation.vue'; //
import { TranslateResult } from 'vue-i18n';
import { GridApi } from 'ag-grid-community';
import { consoleSandbox } from '@sentry/utils';
@Component({
  components: {
    'app-confirmacion': Confirmation,
  },
})
export default class FormEditarGeneralTimeStreamax extends Vue {
  @Prop({ default: false }) edited!: any;
  @Prop({ default: false }) esEdicion!: boolean;
  @Prop({ default: {} }) selectedValue: any;
  @Prop({ default: {} }) usuario: any;
  accion!: any;
  ordesList2: any;
  data: any = {};
  rules = {
    required: (value: any) => !!value || 'Required.',
    counter: (value: any) => value.length <= 15 || 'Maximo 15 caracteres',
    soloLetras: (value: any) => {
      return value.match(/^[a-zA-Z]*$/) || 'Solo se permiten letras';
    },
    soloNumeros: (value: any) => {
      return value.match(/^[0-9]*$/) || 'Solo se permiten letras';
    },
    email: (value: any) => {
      if (value != '') {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || 'Invalid e-mail.';
      }
    },
  };
  async getTimeSeleccionado() {
    let self = this;
    this.loadingService.showLoading();
    console.log(this.esEdicion);
    return fetchConfiguracionStreamax(
      { id_camara: this.selectedValue },
      'configCamaras/getConfGeneralStreamax'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          this.loadingService.hideLoading();
          return data.data.data.LISTA;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
          this.loadingService.hideLoading();
          return [];
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error', { timeout: 3000 });
        this.loadingService.hideLoading();
      });
  }
  async getTime() {
    this.ordesList2 = (await this.getTimeSeleccionado()) || [];
    this.data = this.ordesList2[0];
    this.formFields.dateFormat.value = parseInt(this.data['?column?'].DATEM);
    this.formFields.timeFormat.value = parseInt(this.data['?column?'].TIMEM);
    this.formFields.timeZone.value = this.data['?column?'].TIMEZ;
  }
  mounted() {
    this.getTime();
  }
  convertirSegundosAHora(segundos: number): string {
    console.log('prueba:' + segundos);
    const horas = Math.floor(segundos / 3600);
    const minutos = Math.floor((segundos % 3600) / 60);
    const horaString = horas.toString().padStart(2, '0');
    const minutosString = minutos.toString().padStart(2, '0');
    return `${horaString}${minutosString}`;
  }
  formFields: {
    dateFormat: any;
    timeFormat: any;
    timeZone: any;
  } = {
    dateFormat: {
      label: 'Date Format',
      value: 0,
      items: [
        { label: 'MM/DD/YY', id: 0 },
        { label: 'YY-MM-DD', id: 1 },
        { label: 'DD-MM-YY', id: 2 },
      ],
    },
    timeFormat: {
      label: 'Time Format',
      value: 1,
      items: [{ label: '12 Hours', id: 1 }, { label: '24 Hours', id: 0 }],
    },
    timeZone: {
      label: 'Time Zone',
      value: '',
      items: [
        { label: '(GMT-12:00)INTERNATIONAL DATE LINE WEST', id: '-720A' },
        { label: '(GMT-11:00)MIDWAY ISLANDS,SAMOA', id: '-660A' },
        { label: '(GMT-11:00)UNIVERSAL TIME-11', id: '210.-660B' },
        { label: '(GMT-10:00)HAWAII', id: '-600A' },
        { label: '(GMT-09:00)ALASKA', id: '-540A' },
        { label: 'GMT+6', id: '180.000000' },
        { label: '(GMT-08:00)PACIFIC TIME(US & CANADA)', id: '-480A' },
        { label: '(GMT-08:00)BAJA CALIFORNIA', id: '-480B' },
        { label: '(GMT-07:00)CHIHUAHUA,LA PAZ,MAZATLAN', id: '-420A' },
        { label: '(GMT-07:00)MOUNTAIN TIME(US&CANADA)', id: '-420B' },
        { label: '(GMT-07:00)ARIZONA', id: '-420C' },
        { label: '(GMT-06:00)GUADALAJARA, MEXICO CITY', id: '-360A' },
        { label: '(GMT-06:00)SASKATCHEWAN', id: '-360b' },
        { label: '(GMT-06:00)CENTRAL TIME(US & CANADA)', id: '-360C' },
        { label: '(GMT-06:00)CENTRAL AMERICA', id: '-360D' },
        { label: '(GMT-05:00)BOGOTA,LIMA,QUITO', id: '-300A' },
        { label: '(GMT-05:00)EASTERNTIME(US & CANADA)', id: '-300B' },
        { label: '(GMT-05:00)INDIANA(EAST)', id: '-300C' },
        { label: '(GMT-04:30)CARACAS', id: '-270A' },
        { label: '(GMT-04:00)ATLANTIC TIME(CANADA)', id: '-240A' },
        { label: '(GMT-04:00)CUIABA', id: '-240B' },
        { label: '(GMT-04:00)GEORGETOWN,LA PAZ,MANAUS', id: '-240C' },
        { label: '(GMT-04:00)SANTIAGO', id: '-240D' },
        { label: '(GMT-04:00)ASUNCION', id: '-240E' },
        { label: '(GMT-03:30)NEWFOUNDLAND', id: '-210A' },
        { label: '(GMT-03:00)BRASILIA', id: '-180A' },
        { label: '(GMT-03:00)BUENOS AIRES', id: '-180B' },
        { label: '(GMT-03:00)GREENLAND', id: '-180C' },
      ],
    },
  };
  selectedDateFormat() {
    return this.formFields.dateFormat.items.find(
      (item: { id: any }) => item.id === this.formFields.dateFormat.value
    );
  }
  selectedTimeFormat() {
    return this.formFields.timeFormat.items.find(
      (item: { id: any }) => item.id === this.formFields.timeFormat.value
    );
  }
  selectedTimeZone() {
    return this.formFields.timeZone.items.find(
      (item: { id: any }) => item.id === this.formFields.timeZone.value
    );
  }
  //abstract
  readonly funcionalidad: Funcionalidades = Funcionalidades.Streamax;
  //propiedades globales
  loadingService = new LoadingService();
  gridApi: GridApi;
  $snotify: any;
  dialog: boolean = true;
  dialogConfirmacionClose: boolean = false;
  bottomNav: any = '1';
  dictionaryFormErrors: any = {};
  validForm: boolean = false;
  dialogConfirmacion: boolean = false;
  btnBloquear: Boolean = false;
  //Interface
  estadoSwitch: boolean = false;
  //controllers
  readonly controller: string = 'funcionalidad';
  readonly controllerAccion: string = 'accion';
  readonly controllerModuloAccion: string = 'moduloaccion';
  axios: AxiosVue = new AxiosVue(ServicioProxy.GestionUsuario);
}
